<template>
  <GenericWrapperChart :config="config" />
</template>

<script>
import { generateFileName } from '@/utils';

import { GenericWrapperChart } from '@/components/content/GenericWrapperChart';

export default {
  name: 'EngagementOverTime',
  components: {
    GenericWrapperChart,
  },
  data() {
    return {
      title: 'Índice de engajamento ao longo do tempo',
    };
  },
  computed: {
    description() {
      const channelSelected = this.$store.state.ui.channel.toLowerCase();

      const descriptions = {
        default: 'Índice de engajamento = (curtidas + comentários x 1,5 + compartilhamentos x 2) / número de fãs) x 1000 no período selecionado.',
        instagram: 'Índice de engajamento = (curtidas + comentários x 1,5) / número de fãs) x 1000 no período selecionado.',
        youtube: 'Índice de engajamento = (curtidas + comentários x 1,5) / número de views) x 1000 no período selecionado.',
      };

      const descriptionSelected = channelSelected in descriptions ? descriptions[channelSelected] : descriptions.default;

      return descriptionSelected;
    },
    overrideChartOptions() {
      const filename = generateFileName(this.title);

      return {
        exporting: {
          enabled: false,
          sourceWidth: 750,
          filename,
          chartOptions: {
            title: {
              text: this.title,
            },
          },
        },
      };
    },
    config() {
      const isLoading = this.$store.state.charts.engagementOverTime.isLoading;
      const title = !isLoading ? this.title : '';
      const description = !isLoading ? this.description : '';
      const series = this.$store.state.charts.engagementOverTime.data;
      const tooltipConfig = {
        addHeader: true,
        addFooter: false,
        addPercentVariation: false,
      };

      return {
        componentName: 'EngagementOverTime',
        title,
        description,
        isLoading,
        hasError: this.$store.state.charts.engagementOverTime.hasError,
        isEmpty: false,
        onError: this.getEngagementData,
        requestOnMounted: this.getEngagementData,
        downloadMenu: {
          trackNameOnOpen: 'BM ExportEngagementTime Graph Open',
          trackNameOnDownload: 'BM ExportEngagementTime Graph Click',
        },
        chart: {
          type: 'AreaSpline',
          series,
          overrideChartOptions: this.overrideChartOptions,
          tooltipConfig,
          trackNameOnObserve: 'BM EngagementTime Graph View',
          trackNameOnLegendClick: 'BM EngagementTime LegendGraph Click',
        },
        periodSelector: {
          showPeriodSelector: true,
          onPeriodChange: this.getEngagementData,
          trackPeriod: 'BM PeriodEngagementTime Graph Click',
        },
      };
    },
  },
  methods: {
    async getEngagementData({ periodSelected } = {}) {
      await this.$store.dispatch('charts/fetchEngagementOverTime', { datePortion: periodSelected });
    },
  },
};
</script>
